import { ContentType } from '../enums/ContentType';
import { Language } from '../enums/Language';
import { Content } from '../types/Content';

export class MultiLanguageTextModel {
  private _languageTexts: Content[];
  constructor(languageTexts: Content[] = []) {
    this._languageTexts = languageTexts;
  }

  public static from(data: MultiLanguageTextModel) {
    return new MultiLanguageTextModel(data._languageTexts);
  }

  has(language: Language) {
    return this._languageTexts.some((lt) => lt.language == language);
  }

  get(language: Language) {
    return this._languageTexts.find((lt) => lt.language == language);
  }

  addText(language: Language, text: string, contentType = ContentType.TEXT) {
    const existing = this.get(language);
    if (existing) {
      if (existing.contentType === ContentType.HTML) {
        return;
      } else {
        existing.text = text;
        return;
      }
    }
    this._languageTexts.push({ language, text, contentType });
    this._sort();
  }

  combineAddText(language: Language, text: string, separator: string = '\n') {
    const correctLanguageText = this._languageTexts.find(
      (lt) => lt.language == language
    );
    if (correctLanguageText != null) {
      correctLanguageText.text += separator;
      correctLanguageText.text += text;
    } else {
      this.addText(language, text);
    }
  }

  add(other: MultiLanguageTextModel) {
    other._languageTexts.forEach((lt) => {
      this.combineAddText(lt.language, lt.text);
    });
  }

  getText(language: Language): string {
    const correctLanguageText = this._languageTexts.find(
      (lt) => lt.language == language
    )?.text;
    if (correctLanguageText != null) {
      return correctLanguageText;
    }
    if (this._languageTexts.length > 0) {
      return this._languageTexts[0].text;
    }
    return '';
  }

  includes(searchString: string): boolean {
    return this._languageTexts.some((lt) =>
      lt.text.toLowerCase().includes(searchString.toLowerCase())
    );
  }

  private _sort() {
    this._languageTexts.sort((a, b) => {
      if (
        a.contentType === ContentType.HTML &&
        b.contentType !== ContentType.HTML
      ) {
        return -1;
      }
      if (
        a.contentType !== ContentType.HTML &&
        b.contentType === ContentType.HTML
      ) {
        return 1;
      }
      return 0;
    });
  }

  get languageTexts() {
    return this._languageTexts;
  }
}
